import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useParams } from 'react-router-dom';
import SummarySectionsList from './SummarySectionsList';
import { CloseButton, CloseButtonRollover } from '../../shared/svg/components';
import {
  changeIsSummaryOpened,
  downloadPdf,
  initializeSections,
  initializeSummaryCameras,
  saveConfiguration, setIsLoadingUnitStatus, setPopupState,
  setSnackbarMessage,
} from '../../model/configuratorSlice';
import { PopupState, SnackbarMessages } from '../../model/constants';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import DownloadPdfService from '../../services/DownloadPdfService';
import { hasContactFormBeenSent } from '../../utils/contactFormStorage';

const SummaryPanel = () => {
  const {
   settings, isSummaryOpened, summaryShots, legalSettings, currentUnit,
  } = useSelector(state => state.configurator);
  const [topShot, setTopShot] = useState(null);
  const [bottomShot, setBottomShot] = useState(null);

  const dispatch = useDispatch();
  const { promotionSlug } = useParams();

  const downloadPdfMutation = DownloadPdfService();

  useEffect(() => {

  }, [summaryShots]);

  useEffect(() => {
    dispatch(initializeSummaryCameras());
    dispatch(initializeSections());

    if (summaryShots != null && summaryShots.length === 2) {
      setTopShot(summaryShots[0]);
      setBottomShot(summaryShots[1]);
    }
  }, [isSummaryOpened]);

  useEffect(() => {

  }, [summaryShots]);

  return (
    <div className={`summary-panel ${isSummaryOpened ? 'opened' : ''}`}>
      <div className="summary-content">
        <div className="left-container">
          <div className="top-image">
            {topShot !== null && (
              <img src={`${settings.shots_base_url}/${topShot}.jpg`} alt="" />
            )}
          </div>
          <div className="bottom-image">
            {bottomShot !== null && (
              <img src={`${settings.shots_base_url}/${bottomShot}.jpg`} alt="" />
            )}
          </div>
        </div>
        <div className="right-container">
          <button
            type="button"
            className="close-button"
            onClick={() => dispatch(changeIsSummaryOpened(false))}
          >
            <CloseButton className="icon" />
          </button>
          <div className="container-summary-section-list-legal-text">
            <SummarySectionsList />
            <div className="legal-text">{legalSettings.legalNote}</div>
          </div>
          <div className={`summary-buttons-container${!IsNullOrUndefined(currentUnit) ? ' logged-in' : ''}`}>
            {!IsNullOrUndefined(currentUnit) ? (
              <>
                <button
                  className="request-budget-button"
                  type="button"
                  onClick={() => {
                    dispatch(setIsLoadingUnitStatus(true));
                    dispatch(setPopupState(PopupState.RequestBudget));
                  }}
                >
                  <span>Formalizar</span>
                </button>
                <button
                  className="save-button"
                  type="button"
                  onClick={() => {
                    if (!IsNullOrUndefined(currentUnit)) {
                      dispatch(setIsLoadingUnitStatus(true));
                      dispatch(setPopupState(PopupState.CheckForSaveConfiguration));
                    }
                  }}
                ><span>Guardar configuración</span>
                </button>
              </>

            ) : (
              !hasContactFormBeenSent(promotionSlug) && (
                <button
                  className="contact-us-button"
                  type="button"
                  onClick={() => dispatch(setPopupState(PopupState.ContactUs))}
                >
                  <span>Contacta con nosotros</span>
                </button>
              )
            )}
            <button
              className="download-button"
              type="button"
              onClick={() => {
                if (!IsNullOrUndefined(currentUnit)) {
                  dispatch(setIsLoadingUnitStatus(true));
                  dispatch(setPopupState(PopupState.CheckForDownloadPdf));
                } else if (hasContactFormBeenSent(promotionSlug)) {
                  downloadPdfMutation.mutate();
                } else {
                  dispatch(setPopupState(PopupState.CheckForContactBeforeDownload));
                }
              }}
            ><span>Descargar Resumen</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryPanel;
